import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import CustomModal from "components/CustomModal";
import i18next from "i18next";

const ConfirmationDialog = ({
  className,
  btnText,
  dialogText,
  acceptCallback,
  rejectCallback
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleAccept = () => {
    setIsModalOpen(false);
    acceptCallback && acceptCallback();
  };

  const handleReject = () => {
    setIsModalOpen(false);
    rejectCallback && rejectCallback();
  };

  return (
    <>
      <button className={`${className} btn btn-danger`} onClick={handleClick}>
        {btnText}
      </button>
      {isModalOpen && (
        <CustomModal
          dismissible={false}
          showCloseBtn={false}
          isOpen={isModalOpen}
          title={i18next.t("general.confirmation")}
          body={
            <div className="font-weight-normal" style={{ fontSize: "1rem" }}>
              {dialogText}
            </div>
          }
          footer={
            <div>
              <Button className="mr-2" onClick={handleAccept}>
                {i18next.t("general.yes")}
              </Button>
              <Button onClick={handleReject}>{i18next.t("general.no")}</Button>
            </div>
          }
          closeModalCallback={handleReject}
        />
      )}
    </>
  );
};

const StyledConfirmationDialog = styled(ConfirmationDialog)`
  background-color: #ff4433;
  color: #ffffff;
  text-shadow: none;
  filter: none;
  border-radius: 0;
  line-height: 20px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  border: 0;
  box-shadow: none;
  padding: 5px 20px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 4px;
  border-width: 0px;
  border-style: initial;
  border-color: initial;
  border-image: initial;
  margin-right: 20px;
  border-right: 1px solid #DDDDDD;
`;

export default React.memo(StyledConfirmationDialog);
